/**
 * Push Data to Analytics system
 *
 * @param {Object} data
 */
window.cmtaTrackingPush = (data) => {
  if (Object.keys(data).length !== 0 && data.constructor === Object) {
    clubMedLayer.push(data);
  } else {
    console.error("No data to push with 'clubMedLayer' !");
  }
};
